/**
 * CRM Tab Navigation — renders tabs conditionally based on enabled sub-features.
 */

import { useLocation, useNavigate } from 'react-router-dom'
import { useFeature } from '@/hooks/useFeature'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui'
import { CRM_TABS, crmTabFor } from './crmTabs'

/** The CRM shell's tab strip (SA-1125: CrmPage renders it once, under its title). */
export function CrmTabNav() {
  const navigate = useNavigate()
  const activeTab = crmTabFor(useLocation().pathname)

  // Check all features upfront
  const dealsEnabled = useFeature('crm_deals')
  const segmentsEnabled = useFeature('crm_segments')
  const activitiesEnabled = useFeature('crm_activities')
  const companiesEnabled = useFeature('crm_companies')
  const automationsEnabled = useFeature('crm_automations')
  const analyticsEnabled = useFeature('crm_analytics')

  const featureMap: Record<string, boolean> = {
    crm_deals: dealsEnabled,
    crm_segments: segmentsEnabled,
    crm_activities: activitiesEnabled,
    crm_companies: companiesEnabled,
    crm_automations: automationsEnabled,
    crm_analytics: analyticsEnabled,
  }

  const visibleTabs = CRM_TABS.filter(
    (tab) => tab.feature === null || featureMap[tab.feature]
  )

  return (
    <Tabs
      value={activeTab}
      activationMode="manual"
      onValueChange={(v) => {
        const tab = CRM_TABS.find((t) => t.id === v)
        if (tab) navigate(tab.path)
      }}
    >
      <TabsList className="overflow-x-auto">
        {visibleTabs.map((tab) => {
          const Icon = tab.icon
          return (
            <TabsTrigger key={tab.id} value={tab.id}>
              <Icon className="w-4 h-4 mr-1.5" aria-hidden="true" />
              {tab.label}
            </TabsTrigger>
          )
        })}
      </TabsList>
    </Tabs>
  )
}
